/**
 * useDeviceId — Generates and persists a device fingerprint.
 * Uses localStorage + a random UUID as a lightweight device identifier.
 * Not fully tamper-proof (incognito/clearing storage), but raises the bar.
 */

const DEVICE_ID_KEY = "seatech_device_id";

function generateDeviceId(): string {
  return crypto.randomUUID();
}

export function getDeviceId(): string {
  try {
    let id = localStorage.getItem(DEVICE_ID_KEY);
    if (!id) {
      id = generateDeviceId();
      localStorage.setItem(DEVICE_ID_KEY, id);
    }
    return id;
  } catch {
    // Fallback for incognito or blocked localStorage
    return generateDeviceId();
  }
}

export function useDeviceId(): string {
  // Stable — reads from localStorage synchronously
  return getDeviceId();
}
